import { type MaybeRefOrGetter, computed, toValue } from 'vue';

export function useDateTime(date: MaybeRefOrGetter<Date | null>) {
    const formattedDate = computed(() => {
        const dateValue = toValue(date);
        if (!dateValue) return;

        const local = new Date(
            dateValue.getTime() - dateValue.getTimezoneOffset() * 60000
        );
        return local.toISOString().slice(0, 19);
    });

    return { formattedDate };
}
